const tenantId = "130d3ff1-09b7-4ef2-80be-d811fe70ca70";

export default tenantId;
